// Test/Live mode (Stripe-style sandbox), persisted client-side and sent as the `x-rt-mode`
// header on every backend call (see functions-client.ts). Default is `live` — the real app.
// In `test`, the backend returns/writes an isolated sandbox dataset. Mirrors src/lib/theme.ts
// (a React-free persistence helper; the React binding lives in src/mode/ModeContext.tsx).

export type Mode = "live" | "test";
export const MODE_KEY = "rt.mode";

export function isMode(v: unknown): v is Mode {
  return v === "live" || v === "test";
}

export function getMode(): Mode {
  try {
    const v = localStorage.getItem(MODE_KEY);
    return isMode(v) ? v : "live";
  } catch {
    return "live";
  }
}

export function setMode(mode: Mode): void {
  try {
    localStorage.setItem(MODE_KEY, mode);
  } catch {
    /* storage unavailable — session-only */
  }
  applyMode(mode);
}

/** Reflect the mode on <html data-mode="test"> so the banner + chrome can style via CSS. */
export function applyMode(mode: Mode): void {
  try {
    const el = document.documentElement;
    if (mode === "test") el.setAttribute("data-mode", "test");
    else el.removeAttribute("data-mode");
  } catch {
    /* SSR / no document */
  }
}
